import React, { useState } from "react";

export default function FAQLiquid() {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    // {
    //   question:
    //     "What is the difference between the Basic and Premium packages?",
    //   answer:
    //     'The Basic package includes essential features such as a professionally designed landing page, domain name registration, a free SSL certificate, and technical support. The Premium package includes all Basic features plus advanced functionality like "Book Appointment" options.',
    // },
    {
      question: "Can I customize the content and design of my landing page?",
      answer:
        "Certainly. Customization of your landing page can be efficiently managed by our team of experts. You will need to provide us with the specific content and images that fit our existing template.",
    },
    {
      question: "Are there any hidden costs or technical requirements?",
      answer:
        "No, there are no hidden costs or technical requirements beyond what's mentioned in the packages (Customizable based on your requirements). The pricing and features provided are transparent, and our technical support team is available to assist you.",
    },
  ];

  return (
    <section className="section-liquid">
      <div className="container-liquid">
        <div style={{ textAlign: "center", marginBottom: "60px" }}>
          <span className="subheading-liquid">FAQs</span>
          <h2
            className="heading-liquid"
            style={{
              fontSize: "clamp(2rem, 4vw, 3rem)",
              marginTop: "16px",
              marginBottom: "24px",
            }}
          >
            You have{" "}
            <span
              style={{
                background: "var(--gradient-primary)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text",
                color: "#007AFF", // Fallback color
              }}
            >
              Questions ?
            </span>
          </h2>
          <p
            className="text-liquid"
            style={{
              fontSize: "1.2rem",
              maxWidth: "600px",
              margin: "0 auto",
            }}
          >
            Find solutions to common queries in our FAQ section.
          </p>
        </div>

        <div
          style={{
            maxWidth: "800px",
            margin: "0 auto",
          }}
        >
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="glass-secondary"
              style={{
                marginBottom: "20px",
                overflow: "hidden",
                transition: "all 0.3s ease",
              }}
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                style={{
                  width: "100%",
                  padding: "24px",
                  background: "transparent",
                  border: "none",
                  textAlign: "left",
                  cursor: "pointer",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <h3
                  className="heading-liquid"
                  style={{
                    fontSize: "1.2rem",
                    margin: 0,
                  }}
                >
                  {faq.question}
                </h3>
                <span
                  style={{
                    fontSize: "1.5rem",
                    transform:
                      openIndex === index ? "rotate(45deg)" : "rotate(0deg)",
                    transition: "transform 0.3s ease",
                    color: "var(--text-primary-dark)",
                  }}
                >
                  +
                </span>
              </button>

              {openIndex === index && (
                <div
                  style={{
                    padding: "0 24px 24px",
                    animation: "fadeIn 0.3s ease",
                  }}
                >
                  <p
                    className="text-liquid"
                    style={{
                      lineHeight: "1.6",
                    }}
                  >
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
